import { useState, useEffect, useCallback } from 'react';
import { collection, onSnapshot, addDoc, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';

export function useBrands(userId) {
    const [brands, setBrands] = useState([]);

    useEffect(() => {
        if (!userId) {
            setBrands([]);
            return;
        }

        const collectionRef = collection(db, 'users', userId, 'brands');
        const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
            const brandsData = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
            setBrands(brandsData.sort((a, b) => a.name.localeCompare(b.name)));
        });

        return () => unsubscribe();
    }, [userId]);

    const addBrand = useCallback(async (brandName) => {
        if (!userId) return;
        try {
            const collectionRef = collection(db, 'users', userId, 'brands');
            await addDoc(collectionRef, { name: brandName });
        } catch (error) {
            console.error("Erro ao adicionar marca:", error);
            throw error;
        }
    }, [userId]);

    const deleteBrand = useCallback(async (brandId) => {
        if (!userId) return;
        try {
            const docRef = doc(db, 'users', userId, 'brands', brandId);
            await deleteDoc(docRef);
        } catch (error) {
            console.error("Erro ao deletar marca:", error);
            throw error;
        }
    }, [userId]);

    return { brands, addBrand, deleteBrand };
}